import { createContext, useContext } from "react"

export const SimilaritySelectionContext = createContext({})

export function useSimilaritySelection() {
    return useContext(SimilaritySelectionContext)
}
